import Icon from 'veui/components/Icon'
import { IconFileAdd } from 'dls-icons-vue'

Icon.register('file-add', IconFileAdd)
